import { DataTable, Dialog, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import useInvestorInfoMBAPL from "./useInvestorInfoMBAPL";
import { Outlet } from "react-router-dom";
import { INVESTOR_TYPES, INVESTOR_SUB_TYPES_BY_TYPE, InvestorType } from "./AddEdit/consts"

const InvestorInfoKPL = () => {
  const {
    investorType,
    setInvestorType,
    investorSubType,
    setInvestorSubType,
    handleSearch,
    columns,
    investorInfoList,
    isInvestorInfoLoading,
    openDialog,
    setOpenDialog,
    deletedRow,
    onDeleteConfirm,
    isDeletePending,
    onAdd,
  } = useInvestorInfoMBAPL();

  return (
    <div className="p-4 md:p-6">
      {/* Filters */}
      <div className="flex flex-wrap gap-4 items-start mb-6">
        {/* Investor Type */}
        <Select value={investorType} onValueChange={(v) => { 
          setInvestorType(v as InvestorType); 
          setInvestorSubType(""); 
        }}
        >
          <SelectTrigger className="w-[280px] bg-white">
            <SelectValue placeholder="Investor Type" />
          </SelectTrigger>
          <SelectContent>
            {INVESTOR_TYPES.map((t) => (
              <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Sub-Type */}
        <div className="flex flex-col">
          <Select value={investorSubType} onValueChange={setInvestorSubType}>
            <SelectTrigger className="w-[300px] bg-white">
              <SelectValue placeholder="Investor Sub Type" />
            </SelectTrigger>
            <SelectContent>
  {(investorType
    ? INVESTOR_SUB_TYPES_BY_TYPE[investorType]
    : []
  ).map((st) => (
    <SelectItem key={st.value} value={st.value}>
      {st.label}
    </SelectItem>
  ))}
</SelectContent>

          </Select>

          <button
            type="button"
            className="mt-1 text-sm text-blue-600 underline text-end cursor-pointer"
            onClick={() => {
              setInvestorType("");
              setInvestorSubType("");
            }}
          >
            Clear All
          </button>
        </div>

        {/* Search (normal position) */}
        <Button className="px-5 h-[42px]" onClick={handleSearch}>Search</Button>

        {/* + Add (pushed to right) */}
        <div className="ml-auto">
          <Button className="px-5 h-[42px]" onClick={onAdd}>+ Add</Button>
        </div>
      </div>

      {/* Table */}
      {isInvestorInfoLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={investorInfoList.data.items}
        />
      )}

      {/* Delete Dialog */}
      <Dialog
        open={openDialog}
        setOpen={setOpenDialog}
        title="Delete Confirmation"
        saveText="Delete"
        isLoading={isDeletePending}
        onSave={onDeleteConfirm}
      >
        <p>
          Are you sure you want to delete <strong>{deletedRow?.title}</strong>?
        </p>
      </Dialog>

      <Outlet />
    </div>
  );
};

export default InvestorInfoKPL;